
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[siteHandle]",
      function () {
        return require("private-next-pages/[siteHandle]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[siteHandle]"])
      });
    }
  